<template>
  <router-view />
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'App',
    components: {},
    mounted() {
      // On app load, get latest currency conversions
      axios.get('http://ws.jrthompson.com/exchange-rates/usd-base-rates.json')
        .then(res => localStorage.setItem('USDtoCAD', res.data.rates.CAD))
        .catch(() => localStorage.setItem('USDtoCAD', 1.27))
    }
  }
</script>

<style lang="scss">
  @import 'assets/scss/main.scss';
</style>